import {Affix, FloatButton} from 'antd';
import {useEffect, useState} from 'react';
import '../ContentIndex.css';
const logoImg = 'https://zjcnas.oss-cn-hangzhou.aliyuncs.com/images/logo2.png';
const img1 = 'https://zjcnas.oss-cn-hangzhou.aliyuncs.com/images/xm/cf1.jpg';
const img2 = 'https://zjcnas.oss-cn-hangzhou.aliyuncs.com/images/xm/cf2.jpg';
const logo22 = 'https://zjcnas.oss-cn-hangzhou.aliyuncs.com/images/logo22.png';
const weixing = 'https://zjcnas.oss-cn-hangzhou.aliyuncs.com/images/weixing.jpg';
const App = () => {
    useEffect(() => {
        // 配置swiper播放 配置项都写这里面
        // console.log(1232112312)
        // const mySwiper = new Swiper('.swiper', {
        //     autoplay: true,
        //     loop: true
        // })
        window.scrollTo(0, 0);

    }, [])
    const [scrollPosition, setScrollPosition] = useState(0);
    const [top, setTop] = useState(118);
    const scroll=(y)=>{
        window.scrollTo(0, y);
    }

    function createMarkup() {
        return {
            __html: `<div class="nyrcon">
                    <img src="`+img1+`" alt="成分分析" class="pprr">
                    <div class="nyrt"><h1 class="contact-tit">成分分析</h1></div>
                    <div class="cc-pp">
                        <h2><span style="font-size: 16px; color: rgb(0, 0, 0);">成分分析项目介绍</span></h2><p><a style="color: rgb(0, 0, 0); text-decoration: underline;"><span style="color: rgb(0, 0, 0);">成分分析</span></a><span style="color: rgb(0, 0, 0);">是运用科学方法分析产品的成分，并对各个成分进行定性定量，进而还原其配方组成的一个过程，即材料研发领域的“反向工程”；江苏容大作为国内专业成分分析机构，利用质谱、光谱、色谱、核磁等分析仪器对物质成分定性分析和定量分析，实现对多组分复杂样品体系进行分析，为社会各企业带来改善配方、改进技术、掌握核心技术、提高产品性能、降低成本等一系列好处。</span></p><p style="text-align: center;"><img src="`+img2+`" title="成分分析" alt="成分分析" width="342" height="227"></p><h2><span style="font-size: 16px; color: rgb(0, 0, 0);">成分分析操作步骤</span></h2><p><span style="color: rgb(0, 0, 0);"><strong>样品前处理</strong></span></p><p><span style="color: rgb(0, 0, 0);">拿到样品后，会有一个对样品的预处理叫前处理，前处理目的：一是了解样品的物理、化学性质，帮助工程师确定分析思路；二是对样品进行特定的处理，为测试做准备。前处理的过程一般包括溶解性、含水性、pH值测定、固含、洗涤、灰分、离子检测、萃取、过滤、提纯、蒸馏、离心、制样等。</span></p><p><span style="color: rgb(0, 0, 0);"><strong>谱图验证</strong></span></p><p><span style="color: rgb(0, 0, 0);">谱图验证包括一些谱图的分析、比对、定性、定量。通过多个数据来对某种物质进行核对，并最终确定。分析工程师通过谱图的解析、行业知识及经验的判断结合前处理的信息最终给出需要</span><a  style="color: rgb(0, 0, 0); text-decoration: underline;"><span style="color: rgb(0, 0, 0);">成分分析</span></a><span style="color: rgb(0, 0, 0);">的目标样品的组分及含量。</span></p><h2><span style="font-size: 16px; color: rgb(0, 0, 0);">成分分析设备</span></h2><p><span style="color: rgb(0, 0, 0);">实验室配备对未知物进行剖析鉴定的国际先进仪器设备主要有：</span></p><p><span style="color: rgb(0, 0, 0);">气相色谱/质谱联用仪(GC-MS)、等离子发射光谱仪(ICP-AES)、</span></p><p><span style="color: rgb(0, 0, 0);">等离子体质谱仪(ICP-MS)、原子吸收光谱仪、 原子荧光光谱仪、</span></p><p><span style="color: rgb(0, 0, 0);">离子色谱仪、 X射线荧光光谱仪等无机分析仪器。</span></p><p><span style="color: rgb(0, 0, 0);">液相色谱/质谱联用仪(LC-MS)、核磁共振波谱仪(NMR)、</span></p><p><span style="color: rgb(0, 0, 0);">红外光谱仪(IR)、凝胶渗透色谱仪(GPC)等有机化学结构分析仪器</span></p>                    </div>
                </div>`
        };
    }

    return (

        <>
            <FloatButton.BackTop visibilityHeight={0}  style={{zIndex:9999999999999999}}/>
            <div className="fixed is_PC"></div>
            <div className="all_width is_PC">

                <div className="warp">
                    <div className="header">
                         <div className="logo"><a href="#/ContentIndex" style={{float:"left",marginRight:15}}><img src={logoImg} height={108}/></a></div>
                        <div className="new_nav">
                           <ul>
                                <li><a href="#/ContentIndex">首页</a></li>
                                <li><a  href="#/cnas">CNAS认可</a></li>
                                <li><a  href="#/cma">CMA认定</a></li>
                                <li><a  href="#/fanghuo">防火检测</a></li>
                                <li><a  href="#/haishui">海水腐蚀</a></li>
                                <li><a  href="#/jingxiang">金相抛光布</a></li>
                                <li><a   href="#/about">关于我们</a></li>
                            </ul>
                        </div>
                        <div className="vub_B" style={{position:"fixed",top:"30px"}}>联系电话： 18957441030</div>
                    </div>
                </div>
            </div>
            {/*<img src={yemei}/>*/}

            <div className={'service-details'} >
                <Affix offsetTop={top}>
                    <div className="l-box" >
                        <div className="s-plate">
                            <div className="d-nav">
                                <ul>
                                    <li onClick={event => scroll(427)}>
												<span>
													<i></i>成分分析项目介绍</span>
                                    </li>
                                    <li onClick={event => scroll(788)}>
												<span>
													<i></i>成分分析操作步骤</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </Affix>
                <div className={'r-box'}>
                    <div dangerouslySetInnerHTML={createMarkup()}/>
                </div>
            </div>

            {/*<img src={xia} width={'100%'} style={{zIndex:999,position:"relative",marginTop:80,display:"block"}}/>*/}

             <div className="all_fnav is_PC" style={{zIndex:999,position:"relative"}}>
                 <div style={{background:'#fff',height:80}}></div>
                <div className="warp">
                    <div className={'b'}>
                        <img src={logo22} height={108} style={{float:"left"}}/>
                        <div style={{float:"right",lineHeight:'108px',fontSize:'26px',paddingRight:40}}>致力于我国实验室建设、 认证、 扩项、 监督评审、 一站式解决方案</div>
                    </div>
                    <div className="Fanya_footer_nav" style={{color:'#FFF'}}>
                        <ul>
                            <li>
                                
                                <div className="Fanya_footer_nav_TT">CMA资质认定</div>
                                <div className="Fanya_footer_sub">
                                    <dl>
                                        <dt>检验检测机构CMA资质认定</dt>
                                        <dt>机动车检验机构CMA资质认定</dt>
                                        <dt>司法鉴定机构CMA资质认定</dt>
                                        <dt>刑事技术机构CMA资质认定</dt>
                                    </dl>
                                </div>
                            </li>
                            <li><div className="Fanya_footer_nav_TT">CNAS认证认可</div>
                                <div className="Fanya_footer_sub">
                                    <dl>
                                        <dt>ISO17025检测/校准实验室CNAS认可</dt>
                                        <dt>ISO17020检验机构CNAS认可</dt>
                                        <dt>ISO15189医学实验室CNAS认可</dt>
                                        <dt>DILAC国防实验室认可</dt>
                                    </dl>
                                </div>
                            </li>
                            <li style={{marginRight:15}}>
                                <div className="Fanya_footer_nav_TT">联系我们</div>
                                <div className="Fanya_footer_sub">
                                    <dl>
                                        <dt>电话：0574-87636695</dt>
                                        <dt>认证热线：18957441030（胡老师）</dt>
                                        <dt>地址：宁波市高新区检验检测园冬青路258号A幢</dt>
                                        <dt></dt>
                                    </dl>
                                </div>
                            </li>
                            <li>
                                <div className="Fanya_footer_sub" style={{position:"relative"}}>
                                    <img src={weixing} width={160} />
                                    <div style={{background:'red',borderRadius:16,lineHeight:'32px',textAlign:"center",width:160,marginTop:10}}>扫码咨询</div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="all_Fanya_copyright">
                <div className="warp">
                    <div className="Fanya_copyright">版权所有 ◎ 浙江安鉴检测认证服务有限公司 <a
                        href="http://beian.miit.gov.cn/" target="_blank">浙ICP备2024103308号-1</a></div>
                </div>
            </div>
        </>
    );
};
export default App;
